import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { CoverComponent } from './pages/cover/cover.component';
import { AnkitVermaComponent } from './pages/ankit-verma/ankit-verma.component';
import { BishakhaDuttaComponent } from './pages/bishakha-dutta/bishakha-dutta.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavPanelComponent } from './components/nav-panel/nav-panel.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { OverlayComponent } from './components/overlay/overlay.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { GenericModalComponent } from './components/generic-modal/generic-modal.component';
import { HalfSareeComponent } from './pages/half-saree/half-saree.component';
import { GulaboSitaboComponent } from './pages/gulabo-sitabo/gulabo-sitabo.component';
import { NetflixComponent } from './pages/netflix/netflix.component';
import { ArtOfCriticismComponent } from './pages/art-of-criticism/art-of-criticism.component';
import { BreguetComponent } from './pages/breguet/breguet.component';
import { ChanelComponent } from './pages/chanel/chanel.component';
import { MentalHealthComponent } from './pages/mental-health/mental-health.component';
import { GucciComponent } from './pages/gucci/gucci.component';
import { ForewordComponent } from './pages/foreword/foreword.component';
import { AnimationComedyComponent } from './pages/animation-comedy/animation-comedy.component';
import { BollywoodSubtextComponent } from './pages/bollywood-subtext/bollywood-subtext.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavPanelComponent,
    NavBarComponent,
    OverlayComponent,
    NewsletterComponent,
    GenericModalComponent,
    HomeComponent,
    CoverComponent,
    AnkitVermaComponent,
    BishakhaDuttaComponent,
    HalfSareeComponent,
    GulaboSitaboComponent,
    NetflixComponent,
    ArtOfCriticismComponent,
    MentalHealthComponent,
    BreguetComponent,
    ChanelComponent,
    GucciComponent,
    ForewordComponent,
    AnimationComedyComponent,
    BollywoodSubtextComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
